module.exports = __webpack_public_path__ + "79602cbd770b2bf421ec1994080d07b2.pdf";